import React from "react";
import {
  FaWhatsapp,
  FaCheck,
  FaSearch,
  FaMobileAlt,
  FaBullhorn,
  FaEnvelopeOpenText,
  FaTools,
} from "react-icons/fa";
import Footer from "../../components/Footer/footer";
import { deepMerge, useSiteContent } from "../../content/SiteContentContext";
const WHATSAPP_NUMBER = "358443519265";
const copy = {
    fi: {
        badge: "Räätälöidyt yrityssivut alkaen 700 €",
        title: "Verkkosivut yritykselle – täysin räätälöity toteutus",
        lead: "Suunnittelen ja toteutan yrityksen verkkosivut alusta asti palveluidesi, tavoitteidesi ja tarvittavien toimintojen ympärille. Ei valmista sivupohjaa: rakenne, ulkoasu, sisältöpolut, perus-SEO ja yhteydenotto rakennetaan projektin mukaan. Räätälöidyt yrityssivut alkaen 700 €.",
        primaryCta: "Pyydä arvio WhatsAppilla",
        secondaryCta: "Täytä lomake etusivulla",
        pricingCta: "Katso verkkosivujen hinnat",
        trust: ["Täysin räätälöity", "Perus-SEO mukana", "Mobiili ensin", "Selkeä yhteydenotto"],
        whoTitle: "Kenelle yrityssivu sopii?",
        whoLead: "Yrityksille ja palveluntarjoajille, jotka tarvitsevat oman näköisen sivuston, selkeän palvelurakenteen ja helpon reitin yhteydenottoon.",
        who: [
            "Palveluyritykset ja toiminimet",
            "Paikalliset yritykset",
            "Uudet yritykset, joilla ei vielä ole sivuja",
            "Yritykset, joiden nykyinen sivusto on vanhentunut",
            "Toimijat, jotka haluavat selkeämmän ja uskottavamman verkkonäkyvyyden",
        ],
        featuresTitle: "Mitä hyvät yrityksen verkkosivut sisältävät?",
        features: [
            {
                icon: "bullhorn",
                title: "Räätälöity rakenne ja palveluesittely",
                text: "Rakenne ja sisältö suunnitellaan yrityksesi palveluiden ympärille niin, että kävijä ymmärtää nopeasti mitä tarjoat ja miten ottaa yhteyttä.",
            },
            {
                icon: "mobile",
                title: "Mobiilissa toimiva sivusto",
                text: "Sivut suunnitellaan niin, että ne toimivat hyvin puhelimella, tabletilla ja tietokoneella.",
            },
            {
                icon: "contact",
                title: "Helppo yhteydenotto",
                text: "Yhteydenotto voidaan tehdä helpoksi esimerkiksi WhatsApp-painikkeella, yhteydenottolomakkeella tai selkeillä yhteystiedoilla.",
            },
            {
                icon: "search",
                title: "SEO ja löydettävyys",
                text: "Sivuille tehdään perus-SEO: otsikot, metatiedot, hakukoneille luettava sisältö ja selkeä rakenne.",
            },
            {
                icon: "tools",
                title: "Tekniikka tarpeen mukaan",
                text: "Toteutus voi olla kevyt yrityssivusto tai laajempi kokonaisuus, jossa on alasivuja, referenssejä, lomakkeita, mittausta ja tarvittaessa integraatioita.",
            },
        ],
        managementTitle: "Hallinta, nykyisen sivuston siirto ja kasvu",
        managementLead: "Sivuston ei tarvitse jäädä kertaprojektiksi. Toteutus voidaan rakentaa niin, että sisältöjä on helppo ylläpitää ja kokonaisuutta kasvattaa yrityksen mukana.",
        managementCards: [
            {
                icon: "tools",
                title: "WordPress-hallintapaneeli tarvittaessa",
                text: "Tarvittaessa WordPress voidaan jättää sivuston taustalle hallintapaneeliksi. Silloin voit itse päivittää tekstejä, kuvia, palveluita, hintoja ja muuta sisältöä ilman koodin muokkaamista.",
            },
            {
                icon: "contact",
                title: "Nykyiset sisällöt ja domain voidaan säilyttää",
                text: "Jos yritykselläsi on jo verkkosivut, käyttökelpoiset tekstit, kuvat ja muu sisältö voidaan siirtää uuteen toteutukseen. Nykyinen domain voidaan pitää samana ja tärkeät vanhat URL-osoitteet ohjata tarvittaessa oikein.",
            },
            {
                icon: "search",
                title: "Helppo laajentaa SEO:n ja liiketoiminnan mukana",
                text: "Sivustoa voidaan myöhemmin kasvattaa esimerkiksi uusilla palvelu-, referenssi- ja aluekohtaisilla sivuilla. Näin myös hakukonenäkyvyyttä voidaan kehittää ilman koko sivuston rakentamista uudelleen.",
            },
        ],
        referencesTitle: "Yritys- ja verkkosivoreferenssit",
        referencesLead: "Näissä projekteissa yhdistyvät selkeä sisältö, hyvä mobiilikokemus, yhteydenoton helppous ja hakukonenäkyvyys.",
        references: [
            {
                title: "Buukkeri.fi",
                text: "Tapahtumapalveluiden varaus- ja näkyvyysalusta, jossa esiintyjät, palveluntarjoajat ja tarjouspyynnöt muodostavat laajan digitaalisen palvelun.",
                href: "https://buukkeri.fi/",
            },
            {
                title: "Spiderlegs Productions",
                text: "Äänentoiston, esitystekniikan ja vuokrauspalveluiden verkkosivusto, jossa palvelut ja yhteydenotto tuodaan selkeästi esille.",
                href: "https://spiderlegsproductions.com/",
            },
            {
                title: "Relicpaja",
                text: "Käsityöhön ja soitinrakennukseen keskittyvä yrityssivusto, jossa vahva visuaalinen ilme yhdistyy palveluiden ja yhteydenoton selkeään esittelyyn.",
                href: "https://relicpaja.fi/",
            },
            {
                title: "Nico Bertula",
                text: "Muusikon ja esiintyjän moderni verkkosivusto, jossa palvelut, musiikki, referenssit ja yhteydenotto muodostavat selkeän kokonaisuuden.",
                href: "https://nicobertula.fi/",
            },
            {
                title: "Matti Oksa",
                text: "Esiintyjän verkkosivusto, jossa palvelut, keikat ja yhteydenotto on rakennettu helposti löydettäväksi kokonaisuudeksi.",
                href: "https://mattioksa.fi/",
            },
            {
                title: "Trubaduuri Pekka",
                text: "Trubaduurin verkkosivusto, joka esittelee esiintyjän, ohjelmiston ja palvelut selkeästi sekä ohjaa asiakkaan yhteydenottoon.",
                href: "https://trubaduuripekka.fi/",
            },
        ],
        priceTitle: "Räätälöidyt yrityssivut alkaen 700 €",
        priceText: "Kevyt räätälöity yrityssivusto alkaa yleensä noin 700 eurosta. Perus-SEO kuuluu toteutukseen. Tarvittaessa sivustolle voidaan sopia hosting ja tekninen ylläpito 360 €/vuosi. Projektin maksun voi sopia 1–3 erään, ja viimeinen erä maksetaan ennen sivuston julkaisua.",
        priceItems: [
            "Räätälöity rakenne ja ulkoasu",
            "Perus-SEO mukana",
            "Responsiivinen toteutus mobiiliin, tablettiin ja desktopiin",
            "Selkeä yhteydenottopolku",
        ],
        processTitle: "Miten projekti etenee?",
        process: [
            {
                title: "1. Katsotaan tavoite",
                text: "Mitä sivuston pitää kertoa ja mitä kävijän pitäisi tehdä: ottaa yhteyttä, pyytää tarjous tai tutustua palveluihin?",
            },
            {
                title: "2. Suunnitellaan oma rakenne",
                text: "Palvelut, referenssit, yhteydenotto, hinnat ja tärkeimmät sisällöt suunnitellaan yrityksesi tarpeisiin sopivaksi kokonaisuudeksi.",
            },
            {
                title: "3. Julkaistaan ja viimeistellään",
                text: "Sivu viedään julkaisuun, perus-SEO tarkistetaan ja yhteydenotto tehdään mahdollisimman helpoksi.",
            },
        ],
        faqTitle: "Usein kysyttyä yrityksen verkkosivuista",
        faqLead: "Näihin kysymyksiin törmätään usein, kun yritykselle rakennetaan uutta verkkosivustoa.",
        faq: [
            {
                q: "Kenelle yrityssivut sopivat?",
                a: "Sivut sopivat palveluyrityksille, toiminimille, paikallisille yrityksille ja toimijoille, jotka tarvitsevat selkeän ja uskottavan verkkonäkyvyyden.",
            },
            {
                q: "Mitä yrityksen sivuille voidaan lisätä?",
                a: "Sivuille voidaan lisätä palveluesittelyt, kuvat, referenssit, hinnat, yhteydenottolomake, WhatsApp-yhteydenotto, usein kysytyt kysymykset ja hakukoneille luettavaa sisältöä.",
            },
            {
                q: "Paljonko yrityksen verkkosivut maksavat?",
                a: "Kevyt yrityssivusto alkaa yleensä noin 700 eurosta. Lopullinen hinta riippuu sivujen laajuudesta, sisällöistä ja mahdollisista lisätoiminnoista.",
            },
            {
                q: "Sisältyykö sivuihin hakukoneoptimointia?",
                a: "Kyllä. Sivuihin sisältyy perus-SEO, kuten otsikot, metatiedot, selkeä rakenne ja Googlelle luettava sisältö.",
            },
            {
                q: "Voiko sivustoa laajentaa myöhemmin?",
                a: "Kyllä. Sivusto voidaan aloittaa kevyenä kokonaisuutena ja laajentaa myöhemmin esimerkiksi uusilla palvelusivuilla, referensseillä, lomakkeilla tai mittauksella.",
            },
            {
                q: "Voiko verkkosivut maksaa erissä?",
                a: "Kyllä. Projektin maksun voi sopia 1–3 erään, joten kaikkea ei tarvitse maksaa kerralla. Viimeinen erä maksetaan ennen sivuston julkaisua.",
            },
            {
                q: "Saako sivustolle hostingin ja ylläpidon?",
                a: "Kyllä. Tarvittaessa sivustolle voidaan järjestää hosting ja tekninen ylläpito 360 €/vuosi.",
            },
            {
                q: "Voinko päivittää sivuston sisältöjä itse?",
                a: "Kyllä. Tarvittaessa sivusto voidaan toteuttaa niin, että WordPress toimii hallintapaneelina. Sieltä voit päivittää esimerkiksi tekstejä, kuvia, palveluita, hintoja ja referenssejä ilman koodin muokkaamista.",
            },
            {
                q: "Voidaanko nykyisen sivuston sisältö ja domain säilyttää?",
                a: "Kyllä. Nykyiseltä sivustolta voidaan siirtää käyttökelpoiset tekstit, kuvat ja muu sisältö uuteen toteutukseen. Domain voidaan pitää samana, ja tärkeät vanhat URL-osoitteet voidaan ohjata uuteen rakenteeseen oikein.",
            },
            {
                q: "Kuinka nopeasti yrityksen verkkosivut valmistuvat?",
                a: "Kevyt yrityssivusto voidaan usein saada julkaisuvalmiiksi noin 1–2 viikossa, jos tarvittavat materiaalit ja sisällöt ovat käytettävissä. Laajemman kokonaisuuden aikataulu sovitaan erikseen.",
            },
        ],
        finalTitle: "Tarvitseeko yrityksesi selkeämmän verkkosivuston?",
        finalLead: "Laita viesti WhatsAppilla, täytä lomake etusivulla tai laske ensin suuntaa-antava kustannus hinnastolaskurilla.",
    },
    en: {
        badge: "Custom business websites from €700",
        title: "Websites for businesses – fully custom-built",
        lead: "I design and build business websites from the ground up around your services, goals and required functionality. No off-the-shelf template: structure, visual direction, content paths, basic SEO and contact flow are tailored to the project. Custom business websites start from €700.",
        primaryCta: "Request an estimate on WhatsApp",
        secondaryCta: "Fill the form on the front page",
        pricingCta: "See website pricing",
        trust: ["Fully custom-built", "Basic SEO included", "Mobile first", "Clear contact path"],
        whoTitle: "Who is a business website for?",
        whoLead: "For businesses and service providers that need a distinctive website, a clear service structure and an easy path to contact.",
        who: [
            "Service businesses and sole traders",
            "Local businesses",
            "New businesses without a website yet",
            "Businesses with an outdated website",
            "Companies that want a clearer and more credible online presence",
        ],
        featuresTitle: "What can be included on a business website?",
        features: [
            {
                icon: "bullhorn",
                title: "Custom structure and service presentation",
                text: "The structure and content are designed around your services so visitors quickly understand what you offer and how to contact you.",
            },
            {
                icon: "mobile",
                title: "Mobile-friendly website",
                text: "The site is designed to work well on phones, tablets and desktop screens.",
            },
            {
                icon: "contact",
                title: "Easy contact",
                text: "Contact can be made easy with a WhatsApp button, a contact form or clearly presented contact details.",
            },
            {
                icon: "search",
                title: "Basic SEO and visibility",
                text: "Page structure, headings, metadata and crawler-friendly content are considered from the start.",
            },
            {
                icon: "tools",
                title: "Technology when needed",
                text: "The project can be a lightweight business website or a broader solution with multiple pages, references, forms, analytics and integrations when needed.",
            },
        ],
        managementTitle: "Easy management, migration and future growth",
        managementLead: "The website does not need to remain a one-off project. It can be built so content is easy to maintain and the site can grow with your business.",
        managementCards: [
            {
                icon: "tools",
                title: "WordPress admin panel when needed",
                text: "WordPress can be used as the website's content management back end when needed. You can then update text, images, services, prices and other content yourself without editing code.",
            },
            {
                icon: "contact",
                title: "Keep your existing content and domain",
                text: "If you already have a website, useful text, images and other content can be migrated to the new implementation. Your existing domain can stay the same and important old URLs can be redirected correctly when needed.",
            },
            {
                icon: "search",
                title: "Built to expand with SEO and your business",
                text: "The website can later be expanded with new service, reference and location-specific pages. This makes it possible to develop search visibility without rebuilding the entire site.",
            },
        ],
        referencesTitle: "Business and website references",
        referencesLead: "These projects combine clear content, mobile usability, easy contact paths and search visibility.",
        references: [
            {
                title: "Buukkeri.fi",
                text: "A booking and visibility platform for event services, built around performers, service providers and clear inquiry flows.",
                href: "https://buukkeri.fi/",
            },
            {
                title: "Spiderlegs Productions",
                text: "A website for sound, event technology and rental services, with services and contact paths presented clearly.",
                href: "https://spiderlegsproductions.com/",
            },
            {
                title: "Relicpaja",
                text: "A business website for guitar relicing and craftsmanship, combining a strong visual identity with clear service presentation and contact paths.",
                href: "https://relicpaja.fi/",
            },
            {
                title: "Nico Bertula",
                text: "A modern artist website bringing services, music, references and contact options into one clear experience.",
                href: "https://nicobertula.fi/",
            },
            {
                title: "Matti Oksa",
                text: "A performer website where services, gigs and contact options are structured into an easy-to-find whole.",
                href: "https://mattioksa.fi/",
            },
            {
                title: "Trubaduuri Pekka",
                text: "A troubadour website presenting the performer, repertoire and services clearly while guiding visitors towards contact.",
                href: "https://trubaduuripekka.fi/",
            },
        ],
        priceTitle: "Custom business websites from €700",
        priceText: "A lightweight custom business website usually starts from around €700. Basic SEO is included. Hosting and technical maintenance can be arranged for €360/year when needed. The project payment can be split into 1–3 instalments, with the final instalment paid before the website is published.",
        priceItems: [
            "Custom structure and visual design",
            "Basic SEO and crawler-friendly content",
            "Responsive layout for mobile, tablet and desktop",
            "Clear contact path",
        ],
        processTitle: "How the project works",
        process: [
            {
                title: "1. Define the goal",
                text: "What should the website explain and what should visitors do: contact you, request an offer or learn about your services?",
            },
            {
                title: "2. Design the right structure",
                text: "Services, references, contact, prices and key content are designed into a structure that fits your business and is easy to understand.",
            },
            {
                title: "3. Publish and finish",
                text: "The site is launched, basic SEO is checked and contact paths are made as easy as possible.",
            },
        ],
        faqTitle: "Frequently asked questions about business websites",
        faqLead: "Common questions when building a new website for a business.",
        faq: [
            {
                q: "Who are business websites for?",
                a: "They are suitable for service businesses, sole traders, local companies and operators that need a clear and credible online presence.",
            },
            {
                q: "What can be added to a business website?",
                a: "Service sections, photos, references, prices, contact forms, WhatsApp contact, frequently asked questions and crawler-friendly content can be included.",
            },
            {
                q: "How much does a business website cost?",
                a: "A lightweight business website usually starts from around €700. The final price depends on the scope, content and additional features.",
            },
            {
                q: "Is SEO included in the price?",
                a: "Basic SEO is included: clear structure, headings, metadata and crawler-friendly content.",
            },
            {
                q: "Can the website be expanded later?",
                a: "Yes. The site can start as a lightweight version and later be expanded with new service pages, references, forms or analytics.",
            },
            {
                q: "Can the website be paid in instalments?",
                a: "Yes. The project payment can be split into 1–3 instalments, so everything does not need to be paid at once. The final instalment is paid before the website is published.",
            },
            {
                q: "Can hosting and maintenance be included?",
                a: "Yes. Hosting and technical maintenance can be arranged for €360/year when needed.",
            },
            {
                q: "Can I update the website content myself?",
                a: "Yes. When needed, the website can be built with WordPress as the content management back end. You can then update text, images, services, prices and portfolio content without editing code.",
            },
            {
                q: "Can my existing website content and domain be kept?",
                a: "Yes. Useful text, images and other content can be migrated from the existing website. The domain can stay the same, and important old URLs can be redirected correctly to the new structure.",
            },
            {
                q: "How quickly can a business website be completed?",
                a: "A lightweight business website can often be ready to publish in around 1–2 weeks when the required content and materials are available. A larger project is scheduled separately.",
            },
        ],
        finalTitle: "Does your business need a clearer website?",
        finalLead: "Send a WhatsApp message, fill in the form on the front page or calculate an estimated cost with the website price calculator.",
    },
    es: {
        badge: "Webs para empresas a medida desde 700 €",
        title: "Webs para empresas – totalmente a medida",
        lead: "Diseño y desarrollo webs para empresas desde cero, alrededor de tus servicios, objetivos y funcionalidades necesarias. Sin plantillas prefabricadas: estructura, diseño, recorridos de contenido, SEO básico y contacto se adaptan al proyecto. Webs a medida desde 700 €.",
        primaryCta: "Pedir estimación por WhatsApp",
        secondaryCta: "Rellenar formulario en la página principal",
        pricingCta: "Ver precios de páginas web",
        trust: ["Totalmente a medida", "SEO básico incluido", "Móvil primero", "Contacto claro"],
        whoTitle: "¿Para quién es una web de empresa?",
        whoLead: "Para empresas y proveedores de servicios que necesitan una web propia, una estructura clara de servicios y una ruta fácil hacia el contacto.",
        who: [
            "Empresas de servicios y autónomos",
            "Empresas locales",
            "Nuevas empresas sin web todavía",
            "Empresas con una web desactualizada",
            "Empresas que quieren una presencia online más clara y creíble",
        ],
        featuresTitle: "¿Qué puede incluir una web de empresa?",
        features: [
            {
                icon: "bullhorn",
                title: "Estructura y servicios a medida",
                text: "La estructura y el contenido se diseñan alrededor de tus servicios para que el visitante entienda rápidamente qué ofreces y cómo contactar.",
            },
            {
                icon: "mobile",
                title: "Web adaptada al móvil",
                text: "La web se diseña para funcionar bien en móvil, tablet y ordenador.",
            },
            {
                icon: "contact",
                title: "Contacto fácil",
                text: "El contacto puede facilitarse con botón de WhatsApp, formulario o datos de contacto claros.",
            },
            {
                icon: "search",
                title: "SEO básico y visibilidad",
                text: "Estructura, títulos, metadatos y contenido legible para buscadores desde el inicio.",
            },
            {
                icon: "tools",
                title: "Tecnología según la necesidad",
                text: "El proyecto puede ser una web ligera para empresa o una solución más amplia con varias páginas, referencias, formularios, analítica e integraciones cuando haga falta.",
            },
        ],
        managementTitle: "Gestión sencilla, migración y crecimiento futuro",
        managementLead: "La web no tiene que quedarse como un proyecto puntual. Puede construirse para que el contenido sea fácil de mantener y la web pueda crecer junto con el negocio.",
        managementCards: [
            {
                icon: "tools",
                title: "Panel de administración de WordPress cuando haga falta",
                text: "WordPress puede utilizarse como panel de gestión de contenidos. Así puedes actualizar textos, imágenes, servicios, precios y otros contenidos sin tener que editar código.",
            },
            {
                icon: "contact",
                title: "Conserva el contenido y el dominio actuales",
                text: "Si ya tienes una web, los textos, imágenes y otros contenidos útiles pueden trasladarse a la nueva implementación. El dominio actual puede mantenerse y las URL antiguas importantes pueden redirigirse correctamente cuando sea necesario.",
            },
            {
                icon: "search",
                title: "Preparada para crecer con el SEO y el negocio",
                text: "La web puede ampliarse más adelante con nuevas páginas de servicios, referencias y páginas locales. Así se puede mejorar la visibilidad en buscadores sin reconstruir toda la web.",
            },
        ],
        referencesTitle: "Referencias de webs y empresas",
        referencesLead: "Estos proyectos combinan contenido claro, buena experiencia móvil, contacto fácil y visibilidad en buscadores.",
        references: [
            {
                title: "Buukkeri.fi",
                text: "Plataforma de reservas y visibilidad para servicios de eventos, construida alrededor de artistas, proveedores y solicitudes claras.",
                href: "https://buukkeri.fi/",
            },
            {
                title: "Spiderlegs Productions",
                text: "Web para servicios de sonido, técnica de eventos y alquiler, con servicios y contacto claramente visibles.",
                href: "https://spiderlegsproductions.com/",
            },
            {
                title: "Relicpaja",
                text: "Web empresarial de servicios de relicado de guitarras y artesanía, con una identidad visual fuerte y una presentación clara de servicios y contacto.",
                href: "https://relicpaja.fi/",
            },
            {
                title: "Nico Bertula",
                text: "Web moderna de artista que reúne servicios, música, referencias y contacto en una experiencia clara.",
                href: "https://nicobertula.fi/",
            },
            {
                title: "Matti Oksa",
                text: "Web de artista donde servicios, actuaciones y contacto están organizados en un conjunto fácil de encontrar.",
                href: "https://mattioksa.fi/",
            },
            {
                title: "Trubaduuri Pekka",
                text: "Web de trovador que presenta al artista, el repertorio y los servicios con claridad y guía al visitante hacia el contacto.",
                href: "https://trubaduuripekka.fi/",
            },
        ],
        priceTitle: "Webs para empresas a medida desde 700 €",
        priceText: "Una web ligera y a medida para empresa empieza normalmente desde unos 700 €. El SEO básico está incluido. Si es necesario, se puede contratar hosting y mantenimiento técnico por 360 €/año. El pago puede dividirse en 1–3 cuotas y la última se abona antes de publicar la web.",
        priceItems: [
            "Estructura y diseño totalmente a medida",
            "SEO básico y contenido para buscadores",
            "Diseño responsive para móvil, tablet y escritorio",
            "Contacto claro para el cliente",
        ],
        processTitle: "Cómo avanza el proyecto",
        process: [
            {
                title: "1. Definimos el objetivo",
                text: "Qué debe explicar la web y qué debe hacer el visitante: contactar, pedir oferta o conocer tus servicios.",
            },
            {
                title: "2. Diseñamos la estructura adecuada",
                text: "Servicios, referencias, contacto, precios y contenido principal se diseñan en una estructura adaptada al negocio y fácil de entender.",
            },
            {
                title: "3. Publicamos y finalizamos",
                text: "Se lanza la web, se revisa el SEO básico y el contacto se hace lo más fácil posible.",
            },
        ],
        faqTitle: "Preguntas frecuentes sobre webs para empresas",
        faqLead: "Preguntas comunes al construir una nueva web para una empresa.",
        faq: [
            {
                q: "¿Para quién son las webs de empresa?",
                a: "Son adecuadas para empresas de servicios, autónomos, empresas locales y profesionales que necesitan una presencia online clara y creíble.",
            },
            {
                q: "¿Qué se puede añadir a una web de empresa?",
                a: "Se pueden incluir servicios, fotos, referencias, precios, formularios, contacto por WhatsApp, preguntas frecuentes y contenido legible para buscadores.",
            },
            {
                q: "¿Cuánto cuesta una web de empresa?",
                a: "Una web ligera para empresa empieza normalmente desde unos 700 €. El precio final depende del alcance, contenido y funciones adicionales.",
            },
            {
                q: "¿Está incluido el SEO?",
                a: "Sí. Está incluido el SEO básico: estructura clara, títulos, metadatos y contenido legible para buscadores.",
            },
            {
                q: "¿Se puede ampliar la web más adelante?",
                a: "Sí. La web puede empezar como una versión ligera y ampliarse después con nuevas páginas de servicios, referencias, formularios o analítica.",
            },
            {
                q: "¿Se puede pagar la web en cuotas?",
                a: "Sí. El pago puede dividirse en 1–3 cuotas, por lo que no es necesario pagarlo todo de una vez. La última cuota se abona antes de publicar la web.",
            },
            {
                q: "¿Se puede incluir hosting y mantenimiento?",
                a: "Sí. Si es necesario, se puede contratar hosting y mantenimiento técnico por 360 €/año.",
            },
            {
                q: "¿Puedo actualizar yo mismo el contenido de la web?",
                a: "Sí. Cuando sea necesario, la web puede construirse con WordPress como panel de gestión. Así puedes actualizar textos, imágenes, servicios, precios y portfolio sin editar código.",
            },
            {
                q: "¿Se pueden conservar el contenido y el dominio de mi web actual?",
                a: "Sí. Los textos, imágenes y otros contenidos útiles pueden trasladarse desde la web actual. El dominio puede mantenerse y las URL antiguas importantes pueden redirigirse correctamente a la nueva estructura.",
            },
            {
                q: "¿Cuánto tarda en estar lista una web de empresa?",
                a: "Una web empresarial ligera puede estar lista para publicar en aproximadamente 1–2 semanas cuando los contenidos y materiales necesarios están disponibles. Los proyectos más amplios se planifican por separado.",
            },
        ],
        finalTitle: "¿Tu empresa necesita una web más clara?",
        finalLead: "Envíame un mensaje por WhatsApp, rellena el formulario en la página principal o calcula un coste orientativo con la calculadora.",
    },
};
const iconMap = {
    bullhorn: FaBullhorn,
    mobile: FaMobileAlt,
    contact: FaEnvelopeOpenText,
    search: FaSearch,
    tools: FaTools,
};
function buildWhatsAppUrl(lang, whatsappNumber = WHATSAPP_NUMBER) {
    const message = lang === "en"
        ? "Hi Arttu! I am interested in a business website and would like to ask for an estimate."
        : lang === "es"
            ? "Hola Arttu. Estoy interesado en una web para empresa y me gustaría pedir una estimación."
            : "Hei Arttu! Olen kiinnostunut yrityksen verkkosivuista ja haluaisin pyytää arviota toteutuksesta.";
    return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
}
export default function BusinessWebsiteLandingPage({ lang = "fi", prefix = "" }) {
    const siteContent = useSiteContent();
    const currentLang = lang === "en" || lang === "es" ? lang : "fi";
    const t = deepMerge(copy[currentLang], siteContent?.pages?.business?.[currentLang] || {});
    const whatsappUrl = buildWhatsAppUrl(currentLang, siteContent?.settings?.whatsappNumber || WHATSAPP_NUMBER);
    return (<>

      <main className="mx-auto w-full max-w-6xl px-2 pb-24 pt-24 sm:px-4 md:px-6 lg:px-12 xl:px-16">

        <section className="relative overflow-hidden rounded-[2rem] border border-black/10 bg-white/70 px-6 py-10 text-center shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:px-10 md:py-14">

          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-lime-400/20 blur-3xl"/>

          <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-sky-400/20 blur-3xl"/>

          <div className="relative z-10">

            <div className="mb-5 inline-flex rounded-full border border-lime-400/30 bg-lime-400/10 px-4 py-2 text-xs font-bold uppercase tracking-wide text-lime-700 dark:text-lime-300">

              {t.badge}

            </div>

            <h1 className="mx-auto max-w-4xl text-4xl font-bold tracking-tight text-gray-950 dark:text-white md:text-5xl">

              {t.title}

            </h1>

            <p className="mx-auto mt-5 max-w-3xl text-base font-light leading-relaxed text-gray-700 dark:text-gray-200 md:text-lg">

              {t.lead}

            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">

              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 font-bold text-white shadow-lg transition hover:scale-[1.02]">

                <FaWhatsapp className="h-5 w-5"/>

                {t.primaryCta}

              </a>

              <a href={`${prefix || ""}/#contact`} className="inline-flex rounded-full border border-black/10 bg-white/80 px-6 py-3 font-semibold text-gray-950 backdrop-blur transition hover:-translate-y-[1px] dark:border-white/10 dark:bg-white/5 dark:text-white">

                {t.secondaryCta}

              </a>

              <a href={`${prefix || ""}/verkkosivujen-hinta/`} className="inline-flex rounded-full border border-lime-400/40 bg-lime-400/10 px-6 py-3 font-semibold text-lime-800 backdrop-blur transition hover:-translate-y-[1px] dark:text-lime-200">

                {t.pricingCta}

              </a>

            </div>

            <div className="mt-7 flex flex-wrap justify-center gap-2">

              {t.trust.map((item) => (<span key={item} className="rounded-full border border-black/10 bg-white/70 px-3 py-1 text-xs font-bold text-gray-700 dark:border-white/10 dark:bg-black/20 dark:text-gray-200">

                  {item}

                </span>))}

            </div>

          </div>

        </section>

        <section className="mt-14 grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">

          <div className="rounded-2xl border border-black/10 bg-white/80 p-6 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5">

            <h2 className="text-2xl font-bold text-gray-950 dark:text-white">{t.whoTitle}</h2>

            <p className="mt-3 text-gray-700 dark:text-gray-200">{t.whoLead}</p>

            <ul className="mt-6 space-y-3 text-gray-800 dark:text-gray-100">

              {t.who.map((item) => (<li key={item} className="flex items-start gap-3">

                  <span className="mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-lime-400/20 text-lime-700 dark:text-lime-300">

                    <FaCheck className="h-3 w-3"/>

                  </span>

                  <span>{item}</span>

                </li>))}

            </ul>

          </div>

          <div className="rounded-2xl border border-black/10 bg-white/80 p-6 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5">

            <h2 className="text-2xl font-bold text-gray-950 dark:text-white">{t.featuresTitle}</h2>

            <div className="mt-6 grid gap-4 sm:grid-cols-2">

              {t.features.map((item) => {
            const Icon = iconMap[item.icon] || FaBullhorn;
            return (<div key={item.title} className="rounded-2xl border border-black/10 bg-gray-50/80 p-5 dark:border-white/10 dark:bg-black/20">

                    <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-lime-400/20 text-lime-700 dark:text-lime-300">

                      <Icon className="h-4 w-4"/>

                    </div>

                    <h3 className="font-bold text-gray-950 dark:text-white">{item.title}</h3>

                    <p className="mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-200">

                      {item.text}

                    </p>

                  </div>);
        })}

            </div>

          </div>

        </section>

        
        <section className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-3xl font-bold text-gray-950 dark:text-white">
              {t.managementTitle}
            </h2>
            <p className="mt-3 leading-relaxed text-gray-700 dark:text-gray-200">
              {t.managementLead}
            </p>
          </div>

          <div className="mt-8 grid gap-5 md:grid-cols-3">
            {t.managementCards.map((item) => {
            const Icon = iconMap[item.icon] || FaTools;
            return (<article key={item.title} className="rounded-2xl border border-black/10 bg-gray-50/80 p-5 dark:border-white/10 dark:bg-black/20">
                  <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-lime-400/20 text-lime-700 dark:text-lime-300">
                    <Icon className="h-4 w-4"/>
                  </div>
                  <h3 className="font-bold text-gray-950 dark:text-white">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                    {item.text}
                  </p>
                </article>);
        })}
          </div>
        </section>

    <section id="yritys-referenssit" className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">

          <div className="mx-auto max-w-3xl text-center">

            <h2 className="text-3xl font-bold text-gray-950 dark:text-white">

              {t.referencesTitle}

            </h2>

            <p className="mt-3 text-gray-700 dark:text-gray-200">{t.referencesLead}</p>

          </div>

          <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">

            {t.references.map((item) => (<a key={item.title} href={item.href} target="_blank" rel="noopener noreferrer" className="group rounded-2xl border border-black/10 bg-gray-50/80 p-5 transition hover:-translate-y-1 hover:border-lime-400/50 dark:border-white/10 dark:bg-black/20">

                <h3 className="font-bold text-gray-950 group-hover:text-lime-700 dark:text-white dark:group-hover:text-lime-300">

                  {item.title}

                </h3>

                <p className="mt-3 text-sm leading-relaxed text-gray-700 dark:text-gray-200">

                  {item.text}

                </p>

              </a>))}

          </div>

        </section>

        <section className="mt-14 grid gap-6 lg:grid-cols-[0.8fr_1.2fr]">

          <div className="rounded-2xl border border-lime-500/30 bg-lime-500/10 p-6 md:p-8">

            <h2 className="text-3xl font-bold text-gray-950 dark:text-white">{t.priceTitle}</h2>

            <p className="mt-4 leading-relaxed text-gray-800 dark:text-gray-100">{t.priceText}</p>

            <ul className="mt-6 space-y-3 text-gray-800 dark:text-gray-100">

              {t.priceItems.map((item) => (<li key={item} className="flex items-start gap-3">

                  <FaCheck className="mt-1 h-4 w-4 shrink-0 text-lime-600 dark:text-lime-300"/>

                  <span>{item}</span>

                </li>))}

            </ul>

          </div>

          <div className="rounded-2xl border border-black/10 bg-white/80 p-6 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5 md:p-8">

            <h2 className="text-3xl font-bold text-gray-950 dark:text-white">{t.processTitle}</h2>

            <div className="mt-6 grid gap-4">

              {t.process.map((item) => (<div key={item.title} className="rounded-2xl border border-black/10 bg-gray-50/80 p-5 dark:border-white/10 dark:bg-black/20">

                  <h3 className="font-bold text-gray-950 dark:text-white">{item.title}</h3>

                  <p className="mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-200">

                    {item.text}

                  </p>

                </div>))}

            </div>

          </div>

        </section>

        <section className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">

          <div className="mx-auto max-w-3xl text-center">

            <p className="text-xs font-black uppercase tracking-[0.25em] text-lime-700 dark:text-lime-300">

              FAQ

            </p>

            <h2 className="mt-3 text-3xl font-bold text-gray-950 dark:text-white">

              {t.faqTitle}

            </h2>

            <p className="mt-4 leading-relaxed text-gray-700 dark:text-gray-200">

              {t.faqLead}

            </p>

          </div>

          <div className="mt-8 grid gap-4 md:grid-cols-2">

            {t.faq.map((item) => (<article key={item.q} className="rounded-2xl border border-black/10 bg-gray-50/80 p-5 transition hover:-translate-y-1 hover:border-lime-400/50 dark:border-white/10 dark:bg-black/20">

                <h3 className="text-lg font-bold text-gray-950 dark:text-white">

                  {item.q}

                </h3>

                <p className="mt-3 text-sm leading-relaxed text-gray-700 dark:text-gray-200">

                  {item.a}

                </p>

              </article>))}

          </div>

        </section>

        <section className="mt-14 rounded-[2rem] border border-lime-500/30 bg-lime-500/10 p-8 text-center shadow-[0_20px_80px_rgba(0,0,0,0.08)] md:p-10 dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)]">

          <h2 className="mx-auto max-w-3xl text-3xl font-bold text-gray-950 dark:text-white md:text-4xl">

            {t.finalTitle}

          </h2>

          <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-gray-700 dark:text-gray-200">

            {t.finalLead}

          </p>

          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">

            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-7 py-3 font-bold text-white shadow-lg transition hover:scale-[1.02]">

              <FaWhatsapp className="h-5 w-5"/>

              {t.primaryCta}

            </a>

            <a href={`${prefix || ""}/#contact`} className="inline-flex rounded-full border border-black/10 bg-white/80 px-7 py-3 font-semibold text-gray-950 backdrop-blur transition hover:-translate-y-[1px] dark:border-white/10 dark:bg-white/5 dark:text-white">

              {t.secondaryCta}

            </a>

            <a href={`${prefix || ""}/verkkosivujen-hinta/`} className="inline-flex rounded-full border border-lime-400/40 bg-lime-400/10 px-7 py-3 font-semibold text-lime-800 backdrop-blur transition hover:-translate-y-[1px] dark:text-lime-200">

              {t.pricingCta}

            </a>

          </div>

        </section>

      </main>

      <Footer lang={lang} prefix={prefix}/>

    </>);
}